export default "__VITE_ASSET__XUpfZZSX__"